import { setRouterPageLoaded, setRouterPageLoading } from 'ia-react-core';
import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

const useMarkPageLoaded = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    const fakePageId = 99999;
    dispatch(setRouterPageLoading(fakePageId));
    setTimeout(() => { dispatch(setRouterPageLoaded(fakePageId)); }, 300);
  }, [dispatch]);
};

export default useMarkPageLoaded;
